import React from 'react';
import PropTypes from 'prop-types';

import DropdownButton from 'common/components/dropdown-button';
import HelptextTooltip from 'common/components/helptext-tooltip';
import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';

import './index.scss';

class DropdownActions extends React.Component {
  // Extra props passed will be passed along to the DropdownMenu component
  static propTypes = {
    buttonProps: PropTypes.object,
    className: PropTypes.string,
    dropdownProps: PropTypes.object,
    options: PropTypes.array.isRequired,
    triggerLabel: PropTypes.string,
  };

  static defaultProps = {
    buttonProps: {
      type: 'select',
    },
    className: 'Button Button--menu Button--select',
    dropdownProps: {
      menuPosition: 'down-right',
      menuStyle: {
        minWidth: '260px',
      },
    },
    triggerLabel: t('Actions'),
  };

  render() {
    const {isSuperuser, isPartner} = window.settings.user;

    return (
      <span className={'DropdownActions'}>
        {this.props.options.length === 0 ? (
          ''
        ) : (
          <DropdownButton
            buttonChildren={this.props.triggerLabel}
            buttonProps={this.props.buttonProps}
            dropdownChildren={this.props.options.map((option, index) => {
              if (option.hidden) {
                return undefined;
              }
              if (option.lock && !isSuperuser) {
                return undefined;
              }
              if (option.lockPartner && !isPartner) {
                return undefined;
              }
              if (option.separator) {
                return (
                  <li
                    className={'DropdownMenuItem--separator'}
                    key={`separator-${index}`}>
                    <hr className={option.className} />
                  </li>
                );
              }
              return (
                <li
                  key={`${option.label}-${index}`}
                  onClick={(event) => {
                    if (option.disabled) {
                      disableClick(event);
                    } else if (option.onClick) {
                      option.onClick();
                    }
                    // DropdownButton listens for document click, so fire that
                    // to close the menu
                    document.body.click();
                  }}>
                  <a
                    className={`
                    ${option.className ?? ''}
                    DropdownMenuItem${option.disabled ? '--disabled' : ''}
                  `}
                    href={option.href}
                    id={option.id}
                    {...option.dataAttrs}>
                    <SvgSymbol name={option.svgSymbol} />
                    {option.label}
                    {option.lock ? <SvgSymbol name={'lock'} /> : null}
                    {option.lockPartner ? <span className="fa-partner"/> : null}
                    {option.tooltip ? (
                      <HelptextTooltip>{option.tooltip}</HelptextTooltip>
                    ) : null}
                  </a>
                </li>
              );
            })}
            dropdownProps={this.props.dropdownProps}
          />
        )}
        {this.props.options.map((option) => {
          return (
            option.modal && <span key={`${option.label}`}>{option.modal}</span>
          );
        })}
      </span>
    );
  }
}

const disableClick = (evnt) => {
  evnt.preventDefault();
  evnt.stopPropagation();
};

export default DropdownActions;
